import {
  makeStyles,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@material-ui/core";
import { Fragment, useState } from "react";
import { useRefresh, useNotify, useMutation, Button } from "react-admin";
import SaveIcon from "@material-ui/icons/Save";

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  table: {
    marginTop: "10px",
    minWidth: 650,
    padding: "1rem",
  },
});

interface IApproveAllButton {
  subcontractorPurchaseInvoiceSummaryId: number;
}

const CustomConfirmButton = ({
  subcontractorPurchaseInvoiceSummaryId,
}: IApproveAllButton) => {
  const refresh = useRefresh();
  const notify = useNotify();

  const [approve, { loading }] = useMutation(
    {
      type: "customUpdate",
      resource: `subcontractorPurchaseInvoiceSummaries/${subcontractorPurchaseInvoiceSummaryId}/approveAllPurchaseInvoice`,
      payload: {},
    },
    {
      onSuccess: ({ data }) => {
        notify(`Successfully approve all purchase invoices.`, "info");
        refresh();
      },
      onFailure: (error) =>
        notify(
          `Failed approve all purchase invoices, error: ${error.message}`,
          "warning"
        ),
    }
  );

  return (
    <Button
      onClick={approve}
      color="primary"
      label={loading ? "Please wait..." : "Confirm"}
      autoFocus
    >
      <SaveIcon />
    </Button>
  );
};

const ApproveAllButton = ({
  subcontractorPurchaseInvoiceSummaryId,
}: IApproveAllButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Fragment>
      <Button
        label={`Approve All`}
        onClick={handleOpenDialog}
        style={{ backgroundColor: "#ffbf00" }}
      />
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Approve All The Draft Purchase Invoices
        </DialogTitle>
        <DialogContent>
          <DialogContentText color="initial">
            Are you sure you want to approve all the draft purchase invoices?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="secondary" label="Back" />
          <CustomConfirmButton
            subcontractorPurchaseInvoiceSummaryId={
              subcontractorPurchaseInvoiceSummaryId
            }
          />
        </DialogActions>
      </Dialog>
    </Fragment>
  );
};

export default ApproveAllButton;
